import { render, staticRenderFns } from "./EcommerceDashboard.vue?vue&type=template&id=bd562340"
import script from "./EcommerceDashboard.vue?vue&type=script&lang=js"
export * from "./EcommerceDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports